import { render, staticRenderFns } from "./AccredInfoExtended.vue?vue&type=template&id=bd116d90&scoped=true&"
import script from "./AccredInfoExtended.vue?vue&type=script&lang=js&"
export * from "./AccredInfoExtended.vue?vue&type=script&lang=js&"
import style0 from "./AccredInfoExtended.vue?vue&type=style&index=0&id=bd116d90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd116d90",
  null
  
)

export default component.exports